export default __webpack_public_path__ + "static/parlens-223de21ea3ca2e1ab38ab2380d7874e1.svg";